import { TooltipPosition } from '@angular/material/tooltip';
import { Timezone, WeekDefinition } from '@herrenknecht-connected/shared-util-idm';

export interface MenuItem {
  lang?: string;
  weekDef?: WeekDefinition;
  timezone?: Timezone;
  i18nKey: string;
  i18nKeyTooltip?: string;
  keyTooltipPosition?: TooltipPosition;
  i18nParams?: Record<string, string>;
  disabled?: (x: MenuItem) => boolean;
  iconName: string;
  callback?: () => void;
  children?: MenuItem[];
  isSelected?: (x: MenuItem) => boolean;
  type?: MenuItemType;
  hidden?: (x?: MenuItem) => boolean;
}

// noinspection JSUnusedGlobalSymbols
export enum MenuItemType {
  Button = 'button',
  Separator = 'separator',
  Footer = 'footer',
}
